module.exports = __webpack_public_path__ + "img/step-2.64cc310e.png";